
export default class DuplicateContextError extends Error {}